<section class="py-3 py-md-5 min-vh-100 d-flex justify-content-center align-items-center">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="text-center">
            <h2 class="d-flex justify-content-center align-items-center gap-2 mb-4">
              <span class="display-1 fw-bold">4</span>
              <i class="bi bi-exclamation-circle-fill text-danger display-4">0</i>
              <span class="display-1 fw-bold bsb-flip-h">3</span>
            </h2>

            <h3 class="h2 mb-2">STOP! Bạn đang cố gắng truy cập vào chức năng bị hạn chế!</h3>
            <h3 class="h2 mb-2">Truy cập bị từ chối</h3>
            <a class="btn bsb-btn-5xl btn-dark rounded-pill px-5 fs-6 m-0" href="" role="button">Quay lại trang chủ</a>
          </div>
        </div>
      </div>
    </div>
  </section>


